// chalktalk-react/components/GroupActivityContent/AnswersTrayContent.tsx
import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import Box from '@components/Atoms/Box';
import AnswerExplanation from '../../containers/AnswerExplanation/AnswerExplanation';
import ReviewAnswered from './ReviewAnswered';

interface AnswersTrayContentProps {
  showAnswers: boolean;
  onToggleAnswers: () => void;
  bellringerMode: boolean;
  explanation: object;
  questionId: number;
  status: string;
  openReportErrorModal: (type: any, id: number) => void;
  answeredByGroup: any[];
  answeredByStudent: any[];
}

const AnswersTrayContent: React.FC<AnswersTrayContentProps> = ({
  showAnswers,
  onToggleAnswers,
  bellringerMode,
  explanation,
  questionId,
  status,
  openReportErrorModal,
  answeredByGroup,
  answeredByStudent,
}) => (
  <Box display="flex" flexDirection="column" height="100%">
    <Box p={1} sx={{ borderBottom: '1px solid #eee', flexShrink: 0 }}>
      <FormControlLabel
        label={showAnswers ? 'Hide Answers' : 'Show Answers'}
        control={<Switch checked={showAnswers} />}
        onChange={onToggleAnswers}
      />
    </Box>
    <div
      data-blur-container=""
      aria-hidden={!showAnswers || undefined}
      {...(!showAnswers ? { inert: '' } : {})}
      style={{
        flex: 1,
        overflow: 'auto',
        transition: 'all .3s ease',
        filter: showAnswers ? 'none' : 'blur(5px)',
        backgroundColor: showAnswers ? 'transparent' : 'rgba(0, 0, 0, 0.2)',
      }}
    >
      <AnswerExplanation
        explanation={explanation}
        openReportErrorModal={showAnswers ? openReportErrorModal : () => {}}
        questionId={questionId}
        unSetHeight
      />
      {status === 'review' && !bellringerMode && (
        <ReviewAnswered
          answeredGroups={answeredByGroup}
          answeredStudents={answeredByStudent}
        />
      )}
    </div>
  </Box>
);

export default AnswersTrayContent;
